export default "__VITE_ASSET__86922832__"